export const MOBILE_SEARCH_ROUTE = 'search';
